module.exports = __webpack_public_path__ + "img/cars-background-poster.9c770b8a.jpg";